import React, { FC, useEffect, useState } from "react";
import { Select } from "antd";
import { defaultTimeInterval24 } from "./constant";
import { Input } from "antd";
import moment from "moment";
import { cloneDeep } from "lodash";
const { Option } = Select;

// const getMatchedVal = (str: string, timeInterval: any[]) => {
//     let matchedVal: any = [];
//     timeInterval.forEach(time => {
//         if(time.includes(str))
//             matchedVal.push({value : time});
//     });
//     return matchedVal;
// };

// const validateTimings = (event: any, setterFn: Function, timeInterval: any) => {
//     const val = event.target.value;
//     if(val && (timeInterval ? !isValidTime(val) : !isValidTime(val, true))) {
//         setterFn('');
//         event.target.focus();
//     }
// }

type InputTimingsProps = {
  value: any;
  onChange: any;
  timeInterval?: any[];
  disabled?: boolean;
  timeslot?: boolean;
  date?: any;
  fromTime?: any;
  isToDate?: any;
  refreshToTime?: boolean;
};

const convertTime12to24 = (time12h: any) => {
  const modifier = time12h.trim().slice(-2);
  const time = time12h.trim().slice(0, 5);
  let [hours, minutes] = time.split(":");
  if (hours === "12") {
    hours = "00";
  }
  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}`;
};

// function tConvert(time: string | (string | number)[]) {
//   // Check correct time format and split into components
//   let _time: any = time?.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

//   if (_time.length > 1) {
//     // If time format correct
//     _time = _time.slice(1); // Remove full string match value
//     _time[5] = +_time[0] < 12 ? " AM" : " PM"; // Set AM/PM
//     _time[0] = +_time[0] % 12 || 12; // Adjust hours
//   }
//   return _time.join(""); // return adjusted time or original string
// }

const TimingDropdown: FC<InputTimingsProps> = ({ value, onChange, timeInterval, disabled, timeslot, date, fromTime, isToDate, refreshToTime }: InputTimingsProps) => {
  const options = defaultTimeInterval24.filter((timeStamp: any) => {
    let forToDatecomparison = isToDate ? (fromTime && fromTime !== "" ? moment(date + " " + fromTime, "YYYY-MM-DD HH:mm") : moment()) : moment();
    return moment(date + " " + timeStamp, "YYYY-MM-DD hh:mm A") >= forToDatecomparison;
  });
  const [sel, setSel] = useState(true);
  const time = value && value !== "" ? moment(value, "HH:mm").format("hh:mm A") : "";
  const [inputTime, setInputtime] = useState<any>(null);
  const [selectTime, setSelectTime] = useState<any>(null);

  useEffect(()=>{
    setInputtime(cloneDeep(time));
    setSelectTime(cloneDeep(time));
  }, [time]);

  useEffect(() => {
    console.log("TimingDropdown.useEffect");
    const ti = value && value !== "" ? moment(value, "HH:mm").format("hh:mm A") : "";
    setInputtime(ti);
    setSelectTime(ti);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshToTime]);

  const fromChange = (data: string) => {
    setSel(false);
    if (data.toLowerCase().includes("am") || data.toLowerCase().includes("pm")) {
      onChange(convertTime12to24(data));
      setSelectTime(data);
      setInputtime(data);
    }
  };

  useEffect(() => {
    console.log("TimingDropdown.useEffect");
    if (timeslot) {
      setSel(false);
      const ti = value && value !== "" ? moment(value, "HH:mm").format("hh:mm A") : "";
      setInputtime(ti);
      setSelectTime(ti);
      onChange(convertTime12to24(value.toUpperCase()));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeslot]);
  const searchFrom = (searchText: string) => {
    // setOptions(
    //   getMatchedVal(searchText,  defaultTimeInterval24)
    // );
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      setSel(true);
      setInputtime(selectTime);
    }
  };

  const onBlurInput = () => {
    setSel(true);
    setInputtime(selectTime);
    onChange(convertTime12to24(selectTime));
  };

  const onInputChange = (inputvalue: any) => {
    setInputtime(inputvalue);
    let meridian =
      inputvalue
        .trim()
        .toLowerCase()
        .slice(0 - 2)
        .includes("am") ||
      inputvalue
        .trim()
        .toLowerCase()
        .slice(0 - 2)
        .includes("pm");
    if (meridian) {
      setSelectTime(inputvalue.toUpperCase());
    }
  };

  return value && !sel ? (
    <Input style={{ width: 100 }} value={inputTime} onKeyDown={(e) => handleKeyDown(e)} onBlur={() => onBlurInput()} onChange={(e) => onInputChange(e.target.value)} disabled={disabled} />
  ) : (
    <Select
      style={{ width: 100 }}
      onBlur={() => setSel(false)}
      optionFilterProp="children"
      onSearch={searchFrom}
      onChange={fromChange}
      value={selectTime}
      disabled={disabled}
      placeholder="__:__"
      filterOption={(input, option: any) => option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    >
      {options.map((option, index) => (
        <Option key={index} value={option}>
          {option}
        </Option>
      ))}
    </Select>
  );
};

export default TimingDropdown;
